import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from './firebase'

export async function accountInit() {
  try {
    await setDoc(doc(db, 'users', auth.currentUser.uid), {
      userName: "ユーザー",
      itemList: [2],// [itemId, itemId, itemId]
    });
    await setDoc(doc(db, 'point', auth.currentUser.uid), {
      totalPoint: 0,
      rank: 0,
    });
  } catch (err) {
    console.error("Error at accountInit(): ", err);
    window.location.href = '/error';
  }
}
